import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/Modal';

const SystemMessage = ({ isOpen, message, onCloseMessage, onAfterClose }) => (
	<Modal
		isOpen={isOpen}
		autoClose={3000}
		theme="notify"
		onRequestClose={onCloseMessage}
		onAfterClose={onAfterClose}
	>
		{message}
	</Modal>
);

SystemMessage.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	message: PropTypes.string,
	onCloseMessage: PropTypes.func,
	onAfterClose: PropTypes.func
};

export default SystemMessage;
